<template>
    <card>
        <template v-slot:header>Buchungen heute</template>

        <chart-donut
                class="mb-2"
                :data="data"
                headline="FooBar"
                :colors="colors"></chart-donut>
    </card>
</template>

<script>
    import Card from "./UI/Card";
    import ChartDonut from "./Chart/ChartDonut";

    export default {
        name: "ScheduleStatistics",

        components: {ChartDonut, Card},

        data: () => ({
             colors: ['#FF968A','#CCE2CB','#FFDAC1']
        }),

        props: ['currentRentingCount', 'free', 'owners'],

        computed: {
            data() {
                return [{label: 'Gebucht', value: this.currentRentingCount}, {label: 'Verfügbar', value: this.free}];
            }
        }
    }
</script>

<style scoped>

</style>
